/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PerformanceInsights {
    angular.module("meevo.plugins.performanceInsights", []);
}
